import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService } from 'src/app/services/convert.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { IAppSlide, IExplore } from 'src/app/interfaces/book-store';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { MappingService } from 'src/app/services/mapping.service';

@Component({
  selector: 'app-add-new-and-trending',
  templateUrl: './add-new-and-trending.component.html',
  styleUrls: ['./add-new-and-trending.component.scss']
})
export class AddNewAndTrendingComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
 
  TITLE = `Add new book`
  form: FormGroup;
  book: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;

  ITEM: IAppSlide;
  BOOK_LIST: any;

  constructor(
    public dialogRef: MatDialogRef<AddNewAndTrendingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: BookstoreStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private storage: FireStorageService
  ) { }


  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }

  displayItem(item: any): string {
    return item ? item.name : item;
  }

  async ngOnInit() {
    this.form = this.fb.group({
      book: [null, Validators.compose([MappingService.validSelected.bind(this)])],
      showInSection: [null],
    })
    this.book = this.form.controls['book'];

    const { ITEM, TITLE } = this.data;
    this.TITLE = `Add new ${TITLE}`
    this.ITEM = ITEM;
    const BOOK_LIST = await this.store.fetchListArray(COLLECTION_NAME.BOOK_STORE_BOOKS, "name");
    this.BOOK_LIST = MappingService.autoComplete(this.book, BOOK_LIST, "name");
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    if (this.form.valid) {
      this.processClose = isDraft ? false : true;
      this.processNew = isDraft;
      this.form.disable();
      const { ITEM } = this.data;
      const { user } = this.auth;
      this.error = null;
      this.isCreate = true;
      const { book, showInSection } = f;
      const registerStatus = STATUS_OBJECT.submitted;

      const item: IExplore = {
        key: ITEM ? ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ITEM ? ITEM.page_key : ConvertService.pageKey(),
        keyword: null,
        organizationRef: null,
        organizationKey: null,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        bookRef: this.ds.firestoreRef().collection(COLLECTION_NAME.BOOK_STORE_BOOKS).doc(book.key).ref,
        bookKey: book.key,
        showInSection: showInSection || false,
        isBook:book.license,
        copyright:book.copyright,
        priceOption:book.priceOption,
      }
      
      this.store.addNewItem(this.data.COLLECTION, item, (success, res) => {
        if (success) {
          this.store.fetchData(this.data.COLLECTION, registerStatus.key)
          this.snackBar.open(`${this.data.TITLE} has been created successful.`, "Done", { duration: 2500 });
          this.form.reset();
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
        if (!isNew) {
          this.dialogRef.close('yes');
        }
      })
    }
  }
}
